import React from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Header2 from '../components/Header2';
toast.configure()
const SOrder = () => {
    const shopcart = {
        paddingTop: "70px",
        paddingBottom: "90px",
    };
    
    const shop__cart__table = {
        marginBottom: "30px",
    
        table : {
            width: "100%",
        },
    
        thead : {
            borderBottom: "1px solid #f2f2f2",
    
            th : {
                fontSize: "18px",
                color: "$heading-color",
                fontWeight: "600",
                textTransform: "uppercase",
                paddingBottom: "20px",
            },
        },
    
        tbody : {
    
            tr : {
                borderBottom: "1px solid #f2f2f2",
    
                td : {
                    padding: "30px 0",
                },
    
                cart__product__item : {
                    overflow: "hidden",
                    width: "585px",
    
                    img : {
                        float: "left",
                        marginRight: "25px",
                    },
    
                    cart__product__item__title : {
                        overflow: "hidden",
                        paddingTop: "23px",
    
                        h6 : {
                            color: "$heading-color",
                            fontWeight: "600",
                        },
    
                        rating : {
    
                            i : {
                                fontSize: "10px",
                                color: "#e3c01c",
                                marginRight: "-4px",
                            },
                        },
                    },
                },
    
                cart__price : {
                    fontSize: "16px",
                    color: "$primary-color",
                    fontWeight: "600",
                    width: "190px",
                },
                cart__close : {
                    textAlign: "right",
    
                    span : {
                        height: "45px",
                        width: "45px",
                        background: "#f2f2f2",
                        borderRadius: "50%",
                        fontSize: "18px",
                        color: "$heading-color",
                        lineHeight: "44px",
                        textAlign: "center",
                        display: "inline-block",
                        fontWeight: "600",
                        cursor: "pointer",
                    },
                },
            },
        },
    };
    
    const cart__btn = {
        marginBottom: "50px",
    
        update__btn : {
            textAlign: "right",
        },
    
        a : {
            fontSize: "14px",
            color: "$heading-color",
            fontWeight: "600",
            textTransform: "uppercase",
            display: "inline-block",
            padding: "14px 30px 12px",
            background: "#f5f5f5",
    
            span : {
                color: "$primary-color",
                fontSize: "14px",
                marginRight: "5px",
            },
        },
    };
    return (
        <div>
            <Header2 />
            <section style={shopcart}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div style={shop__cart__table}>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Product</th>
                                            <th>Price</th>
                                            <th>Quantity</th>
                                            <th>Slot</th>
                                            <th>Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td style={shop__cart__table.tbody.tr.cart__product__item}>
                                            <div style={shop__cart__table.tbody.tr.cart__product__item.cart__product__item__title}><h4>Cake</h4>
                                            </div>
                                        </td>
                                        <td style={shop__cart__table.tbody.tr.cart__price}>1500</td>
                                        <td style={shop__cart__table.tbody.tr.cart__price}>1</td>
                                        <td style={shop__cart__table.tbody.tr.cart__price}>
                                            <div><span class="badge badge-succes">1:00:00PM</span>
                                            </div>
                                        </td>
                                        <td style={shop__cart__table.tbody.tr.cart__price}>1500</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-6">
                            <div style={cart__btn}>
                                <a href="/CloudCart-Preview/#/shops/Dash">Continue in Dashboard</a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};
export default SOrder;